import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => {
  return {
    paper: {
      // boxShadow: '0 1px 1px rgba(0, 0, 0, 0.01), 0 10px 30px rgba(0,0,0,0.08)',
      boxShadow: theme.boxShadow,
      padding: '15px 30px',
      width: '100%',
      marginTop: 30,
      marginBottom: 30,
      textAlign: 'left',
      position: 'relative',
    },
    bar: {
      margin: 0,
      '&:before': {
        top: 0,
        left: 0,
        width: 5,
        height: '100%',
        content: '\'\'',
        position: 'absolute',
        background: theme.primaryColor,
      },
    },
  };
});

function TitleBar(props) {
  const {
    title,
  } = props;
  const classes = useStyles();
  return (
    <>
      <Paper elevation={0} className={classes.paper}>
        <h2 className={classes.bar}>{title}</h2>
      </Paper>
    </>
  );
}

export default TitleBar;
